'use strict'

import Vue from 'vue'
import axios from 'axios'
import firebase from 'firebase/app'
import store from '@/store'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

if (process.env.VUE_APP_AWS_API_BASE_URL) axios.defaults.baseURL = process.env.VUE_APP_AWS_API_BASE_URL
axios.defaults.headers.common['X-Api-Key'] = process.env.VUE_APP_AWS_API_KEY

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

let isRetry = true

const _axios = axios.create(config)

_axios.interceptors.request.use(
  async function (config) {
    let token
    let user
    try {
      user = firebase.auth().currentUser
      if (user) token = await user.getIdToken()
    } catch (error) {
      if (error && (error['code'] === 'auth/user-token-expired' || error['message'] === 'TOKEN_EXPIRED')) {
        // 1. 토큰이 만료되었을 경우 firebase admin sdk 를 사용하여 유저 토큰정보를 다시 받아온다.
        // 2. 그 이후 lambda 에서 받은 token 으로 재로그인
        try {
          await store.dispatch('getUserToken', user['uid'])
          let result = store.getters.userToken
          let userResult = await firebase.auth().signInWithCustomToken(result)

          user = userResult
          token = result
        } catch (error) {
          console.log('sign in with token error  ', error)
        }
      }
    }
    if (user && token) {
      // 유저 설정
      await store.dispatch('setCurrentUser', user)
      // api header Authorization 설정
      await store.dispatch('setApiHeader')

      config.headers['Authorization'] = `bearer ${token}`
    }
    // const user = firebase.auth().currentUser

    // if (user) {
    //   let token = await user.getIdToken()

    //   // 유저 설정
    //   await store.dispatch('setCurrentUser', user)
    //   // api header Authorization 설정
    //   await store.dispatch('setApiHeader')

    //   config.headers['Authorization'] = `bearer ${token}`
    // }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response.data
  },
  async function (error) {
    // Do something with response error
    if (
      error.config &&
      error.message &&
      error.message !== null &&
      (error.message.includes('Network Error') || error.message.includes('403')) &&
      // error.response &&
      // (error.response.status === 401 ||
      //   error.response.status === 403 ||
      //   (error.message && error.message.includes('Network Error'))) &&
      isRetry
    ) {
      let user
      let token
      try {
        user = firebase.auth().currentUser
        if (user) token = await user.getIdToken()
      } catch (error) {
        if (error && (error['code'] === 'auth/user-token-expired' || error['message'] === 'TOKEN_EXPIRED')) {
          // 1. 토큰이 만료되었을 경우 firebase admin sdk 를 사용하여 유저 토큰정보를 다시 받아온다.
          // 2. 그 이후 lambda 에서 받은 token 으로 재로그인
          try {
            await store.dispatch('getUserToken', user['uid'])
            let result = store.getters.userToken
            let userResult = await firebase.auth().signInWithCustomToken(result)
            user = userResult
            token = result
          } catch (error) {
            console.log('sign in with token error  ', error)
          }
        }
      }

      error.config.headers['Authorization'] = 'bearer ' + token
      // 유저 설정
      await store.dispatch('setCurrentUser', user)
      // api header Authorization 설정
      await store.dispatch('setApiHeader')
      isRetry = false

      return _axios.request(error.config)
    }
    isRetry = true

    return Promise.reject(error)
  }
)

// eslint-disable-next-line no-unused-vars
Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      },
    },
    $axios: {
      get() {
        return _axios
      },
    },
  })
}

Vue.use(Plugin)

export default Plugin
